// extracted by mini-css-extract-plugin
export default {"viewMore":"index_viewMore_e8tsu","viewMoreLink":"index_viewMoreLink_kEREG"};